import { Trans } from '@lingui/macro';
import * as React from 'react';

export const NewsLetterBoxSubTitleContent = (props: {
  shortTitle?: boolean,
}) => {
  const {
    shortTitle = false,
  } = props;
  if (shortTitle) {
    return (
      <Trans>
        Restez informé
      </Trans>
    );
  }
  return (
    <Trans>
      Actualités et promotions
    </Trans>
  );
};
